// extracted by mini-css-extract-plugin
export default {"price":"HY-z","onSale":"IY-z","msrpLabelPrice":"JY-z","originalPrice":"KY-z","msrpLabel":"LY-z","percentOff":"MY-z"};